import Img from "gatsby-image"

import React, { Component } from "react"

import * as techStyles from "../../styles/Components/techButton.module.css"

export default class TechButton extends Component {
  render() {
    return (
      <div className={techStyles.btn}>
        <a href={this.props.url}>
          {this.props.fluid ? (
            <div className="row">
              <div className={techStyles.text}>{this.props.name}</div>
              <div className={techStyles.img}>
                <Img
                  fluid={this.props.fluid}
                  alt={this.props.name}
                  title={this.props.name}
                />
              </div>
            </div>
          ) : (
            <div className="row">
              <div className={techStyles.only_text}>{this.props.name}</div>
            </div>
          )}
        </a>
      </div>
    )
  }
}
